import ConversationPanel from "./ConversationPanel.tsx";
import CirclePanel from "../circle/CirclePanel.tsx";
import CircleContent from "../circle/CircleContent.tsx";
import ConversationDrawer from "./ConversationDrawer.tsx";
import IntegrationsPage from "../integration/IntegrationsPage.tsx";
import { Box, Grid } from "@mui/material";
import { useTypedSelector } from "../../hooks.tsx";
import * as React from "react";
import { i18n } from "@lingui/core";
import { I18nProvider } from "@lingui/react";
import { useNavigate, useLocation } from "react-router-dom";

function ConversationContainer() {
  const { isLoggedIn, anonymousSession } = useTypedSelector(
    (state) => state.authState,
  );

  const navigate = useNavigate();
  const location = useLocation();

  const [openDrawer, setOpenDrawer] = React.useState(false);
  const [showIntegrations, setShowIntegrations] = React.useState(
    location.pathname === "/integrations",
  );

  if (!(isLoggedIn || anonymousSession)) {
    return (
      <I18nProvider i18n={i18n}>
        <CirclePanel>
          <CircleContent />
        </CirclePanel>
      </I18nProvider>
    );
  }

  if (anonymousSession) {
    return (
      <I18nProvider i18n={i18n}>
        <Grid>
          <ConversationPanel openDrawer={false} />;
        </Grid>
      </I18nProvider>
    );
  } else {
    return (
      <I18nProvider i18n={i18n}>
        <Box width="100%">
          <ConversationDrawer
            openDrawer={openDrawer}
            setOpenDrawer={setOpenDrawer}
            onShowIntegrations={() => {
              setShowIntegrations(true);
              navigate("/integrations");
            }}
            onConversationSelected={() => {
              setShowIntegrations(false);
              if (location.pathname === "/integrations") {
                navigate("/", { replace: true });
              }
            }}
          />
          {showIntegrations ? (
            <IntegrationsPage
              openDrawer={openDrawer}
              setOpenDrawer={setOpenDrawer}
            />
          ) : (
            <ConversationPanel
              openDrawer={openDrawer}
              setOpenDrawer={setOpenDrawer}
            />
          )}
        </Box>
      </I18nProvider>
    );
  }
}

export default ConversationContainer;
